// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__aWia7","colCheckbox":"styles_colCheckbox__3kOlO"};